module.exports = __webpack_public_path__ + "static/media/m_sf_11.808c39b0.png";